import { NgClass, TitleCasePipe } from '@angular/common';
import { Component, computed, input, InputSignal, output } from '@angular/core';
import { IconType, NgIcon } from '@ng-icons/core';
import { cva } from 'class-variance-authority';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-button',
  imports: [NgIcon, TitleCasePipe, RouterModule, NgClass],
  template: `
    <button
      [class]="buttonVariants({ variant: variant(), size: size() })"
      [ngClass]="{
        'opacity-50': disabled()
      }"
      (click)="handleClickedLocal()"
      type="button"
      [routerLink]="routerLink()"
      [disabled]="disabled()"
    >
      {{ title() | titlecase }}
      @if (icon()) {
      <ng-icon [name]="icon()" [size]="iconSize()" />
      }
    </button>
  `,
})
export class ButtonComponent {
  variant = input<'primary' | 'secondary' | 'error'>('primary');
  size = input<'small' | 'regular'>('regular');
  iconSize = computed<string>(() => (this.size() === 'small' ? '12' : '24'));
  title: InputSignal<string> = input('');
  icon: InputSignal<IconType | undefined> = input();
  routerLink = input<string[] | null>(null);
  handleClick = output();
  disabled = input<boolean>(false);

  isClicked = false;

  buttonVariants = cva(
    ' rounded-lg text-nowrap gap-4 flex items-center justify-center hover:cursor-pointer transition-colors duration-300',
    {
      variants: {
        variant: {
          primary:
            'text-white bg-amber-500 border-amber-500 hover:bg-amber-600 hover:border-amber-400',
          secondary:
            'text-amber-800 hover:text-amber-900 bg-[#ffc670] border-amber-400 hover:bg-amber-400 hover:border-amber-200',
          error:
            'text-red-500 bg-red-200 border-red-200 hover:bg-red-500 hover:text-red-200',
        },
        size: {
          small: 'py-1 px-2 min-w-6 min-h-6 border',
          regular: 'py-2 px-3 min-w-10 min-h-10 border-2',
        },
      },
      defaultVariants: {
        variant: 'primary',
        size: 'regular',
      },
    }
  );

  handleClickedLocal(): void {
    if (!this.routerLink()) {
      this.handleClick.emit();
    }
  }
}
